import type { Airflow } from '@aviata/platform-types';

export function isYouthOffer(offer: Airflow.Offer.Entity) {
  return Boolean(offer.features?.youth?.value);
}

export function getHandLuggageFromOffer(offer: Airflow.Offer.Entity) {
  const paxKey = isYouthOffer(offer) ? 'YTH' : 'ADT';

  return offer.flights.flatMap(flight =>
    flight.segments.map(segment => segment.hand_luggage?.free[paxKey] || null),
  );
}

export function isSmartOffer(offer: Airflow.Offer.Entity) {
  return (
    offer.$meta.connect_type === 'VI' ||
    offer.$meta.connect_type === 'OWC' ||
    offer.$meta.connect_type === 'ML'
  );
}
